import React from 'react';
import { noop } from 'lodash';

import { ActionMenuItemType, ActionMenuProps, MenuListItems } from '@lyearn/molecules';
import { BottomSheet, Stack, Typography } from '@lyearn/ui';
import { Image } from '@/components/Image';

import { useBaseCard } from '../Provider';

const DEFAULT_BOTTOM_SHEET_CLASSES = {
  paperAnchorBottom: 'bg-transparent',
};

export type OptionsProps = {
  showOptions: boolean;
  onClose: () => void;
  items: ActionMenuItemType[];
  onAction: ActionMenuProps['onAction'];
};

const Options = ({ showOptions, onClose, items, onAction }: OptionsProps) => {
  const { image, name, type } = useBaseCard();

  return (
    <BottomSheet
      classes={DEFAULT_BOTTOM_SHEET_CLASSES}
      enableContentPanningGesture={true}
      open={showOptions}
      onClose={onClose}
      onOpen={noop}>
      <Stack className="native:pt-8 pt-32 pb-20 ps-20 pe-28">
        <Image
          alt={name!}
          className="flex h-48 w-48 flex-shrink-0 rounded-4"
          height={48}
          src={image!}
          width={48}
        />
        <Stack className="w-5/6 ms-16" direction="col">
          <Typography color="text-text-primary" numberOfLines={1} variant="heading-s">
            {name}
          </Typography>
          <Typography color="text-text-secondary" variant="body-short-02">
            {type}
          </Typography>
        </Stack>
      </Stack>
      <MenuListItems
        className="space-y-4 p-0 pb-32 xs:mb-12 xs:px-8"
        items={items}
        onAction={onAction}
      />
    </BottomSheet>
  );
};

export default React.memo(Options);
